/**
 * @generated SignedSource<<6fbfb1706ab34dc8be7383ffcc18ed0f>>
 * @relayHash 01fffd726d239a3885cdda05ee671cfc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5e63e2c8ebfdf4d965dba277c3c32a8a04deda6abf4222f96546f817f5440d4d

import type { ConcreteRequest } from 'relay-runtime';
export type useIncludeEditorTutorialTemplateGetUserContentQuery$variables = {
  cql: string;
};
export type useIncludeEditorTutorialTemplateGetUserContentQuery$data = {
  readonly isSiteAdmin: boolean | null | undefined;
  readonly search: {
    readonly count: number | null | undefined;
  } | null | undefined;
};
export type useIncludeEditorTutorialTemplateGetUserContentQuery = {
  response: useIncludeEditorTutorialTemplateGetUserContentQuery$data;
  variables: useIncludeEditorTutorialTemplateGetUserContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cql"
  }
],
v1 = [
  {
    "alias": "search",
    "args": [
      {
        "kind": "Variable",
        "name": "cql",
        "variableName": "cql"
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 12
      }
    ],
    "concreteType": "ConfluenceSearchConnection",
    "kind": "LinkedField",
    "name": "confluence_search",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "count"
      }
    ]
  },
  {
    "kind": "ScalarField",
    "name": "isSiteAdmin"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIncludeEditorTutorialTemplateGetUserContentQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIncludeEditorTutorialTemplateGetUserContentQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "01fffd726d239a3885cdda05ee671cfc",
    "id": "5e63e2c8ebfdf4d965dba277c3c32a8a04deda6abf4222f96546f817f5440d4d",
    "metadata": {},
    "name": "useIncludeEditorTutorialTemplateGetUserContentQuery",
    "operationKind": "query",
    "text": "query useIncludeEditorTutorialTemplateGetUserContentQuery($cql:String!){search:confluence_search(cql:$cql,first:12){count},isSiteAdmin}"
  }
};
})();

(node as any).hash = "faa88759211e6aba8a9b90c957005513";

export default node;
